/** @format */

import { api } from 'utility';
import { getCRKeyUrl } from 'URLs';
export function getClientService() {
  return api
    .get(getCRKeyUrl(), {
      params: { offset: 0, size: 50 },
    })
    .then((res) => res.data);
}
